import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useRatioCache } from './cache'
import { toResponseError, type RatioData, type RatioUpdateInput, type RatioUpdateSuccess } from '@terros/common'

export const useUpdateRatio = (): UpdateHookResponse<RatioData, RatioData> => {
  const cache = useRatioCache()

  const mutation = useTantalimMutation<RatioUpdateInput, RatioUpdateSuccess>({ url: '/ratio/update' })

  async function update(ratio: RatioData): Promise<RatioData> {
    try {
      const response = await mutation.mutateAsync({ ratio })
      if (response.ratio) {
        cache.updateItem(response.ratio)
        cache.clearReportColumns()
      }

      return response.ratio
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
